import {useForm} from "react-hook-form";
import React, {useContext, useEffect, useState} from "react";
import {Paper} from "@mui/material";
import strings from "../../../localization";
import DrawerContext from "../../../Context/DrawerContext";
import TablePageContext from "../../../Context/TablePageContext";
import LinearProgress from '@mui/material/LinearProgress';
import { editProjectResourceType, getAllProjectResourceTypes} from "../../../Services/Project/ProjectResourceTypeService";
import ProjectResourceTypeForm from "../../../Components/Forms/Pages/Project/ProjectResourceType/ProjectResourceTypeForm";
import SnackbarContext from "../../../Context/SnackbarContext";

const formRules = {
    'name': {required: true}
}

const EditProjectResourceType = (props) => {

    const {setDrawerTitle} = useContext(DrawerContext);
    const { showMessage } = useContext(SnackbarContext);
    const form = useForm({
        defaultValues: props.data && props.data.length > 0 ? props.data[0] : undefined
    });
    const {data, handleSubmit, getValues, setValue, formState: {errors}} = form;
    const [showLoader, setShowLoader] = useState(false);
    const [parents, setParents] = useState(0);

    useEffect(() => {
        setDrawerTitle(strings.pages.project.projectResourceType.editProjectResourceType.pageTitle);
    });

    useEffect(() => {
        fetch(); 
    },[])

    const fetch = () => {
        getAllProjectResourceTypes().then(response => {
            if (!response || !response.ok) {
                return;
            }
            setParents(response.data);
        });
    }

    const onSubmit = (data) => {

        setShowLoader(true);

        editProjectResourceType(data).then(response => {
            setShowLoader(false);

            if (!response || !response.ok) {
                showMessage(strings.commonMessages.errorEditing, 'error');
                props.onFinish();
                return;
            }

            showMessage(strings.commonMessages.editingSuccessful, 'success');
            props.onFinish();
        });
    }

    const onCancel = () => {
        props.onCancel();
    }

    return <div className='drawer-form'>
        <Paper className='paper'>
            {
                showLoader &&
                <LinearProgress/>
            }
            <ProjectResourceTypeForm
                formRules={formRules}
                values={getValues()}
                setValue={setValue}
                parents={parents}
                errors={errors} data={data} form={form}
                onSubmit={handleSubmit(onSubmit)} onCancel={() => onCancel()}/>
        </Paper>
    </div>
}

export default EditProjectResourceType;